import React from 'react';

interface IListHeaderProps {
    children?: React.ReactNode;
}

export const ListHeader: React.FC<IListHeaderProps> = ({ children}) => {
    return <div className="list-header">{children}</div>;
};
